import { createContext } from "react"

/**
 * @typedef ServerRenderedProps
 * @type {object}
 * @property {{ railsEnv: string, csrfToken: string }} configuration
 * @property {import("app/javascript/source/shared/contexts/DynamicSession").SessionPerson} current_person
 * @property {{ id: number, name: string, contact_website?: string, currency: import("app/javascript/source/giving/donate/form/types").Currency, church_center_app_enabled: boolean, for_staff_testing?: boolean, subdomain?: string }} current_organization
 * @property {import("app/javascript/source/shared/productAnalytics").ProductAnalyticsConfig} product_analytics
 * @property {{ email_only: boolean }} login
 * @property {{ organization_name: string, organization_avatar_url?: string, organization_contact_email: string }} layout
 * @property {{ publishable_key: string, account_identifier: string }} stripe
 * @property {{ visitor: { id: number | null, church_center_created_at?: string }, account: { id: number | null, org_name?: string, church_center_created_at?: string } }} pendo
 * @property {{ app_enabled: boolean, setup_url: string }} smart_banner
 * @property {{ impersonating: boolean }} [staff]
 */

/** @type React.Context<ServerRenderedProps> */
export const ServerRenderedProps = createContext()
